import api from './api';

/**
 * FAQs Service
 * Handles all FAQ management API calls
 */
const faqsService = {
    /**
     * Get all FAQs with pagination and filters
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/admin/faqs${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get FAQ by ID
     * @param {string} id - FAQ ID
     * @returns {Promise<Object>}
     */
    getById: async (id) => {
        return api.get(`/admin/faqs/${id}`);
    },

    /**
     * Create new FAQ
     * @param {Object} data - FAQ data
     * @returns {Promise<Object>}
     */
    create: async (data) => {
        return api.post('/admin/faqs', data);
    },

    /**
     * Update FAQ
     * @param {string} id - FAQ ID
     * @param {Object} data - Updated FAQ data
     * @returns {Promise<Object>}
     */
    update: async (id, data) => {
        return api.put(`/admin/faqs/${id}`, data);
    },

    /**
     * Delete FAQ
     * @param {string} id - FAQ ID
     * @returns {Promise<Object>}
     */
    delete: async (id) => {
        return api.delete(`/admin/faqs/${id}`);
    }
};

export default faqsService;
